export type TicketContext = {
  conversationId: string;
  ticketLabel: string;
};

export function buildTicketPageContext(context: TicketContext) {
  return {
    url: `/conversations/${context.conversationId}`,
    kind: "entity" as const,
    entityType: "conversation" as const,
    entityId: context.conversationId,
    entityLabel: context.ticketLabel,
  };
}

export function formatTicketLabel(externalId: string) {
  const trimmed = externalId.trim();
  return trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
}
